import type { AxiosRequestConfig, RawAxiosRequestHeaders } from "axios";

export interface CPFData {
  cpfTitular: string;
  cpfRespFinanc: string;
}

export type DownloadType = "BOLETO" | null;

export const AWS_AUTH_STORAGE_KEY = "token";

export const getHeaderValues = (
  cpfData: CPFData | null = null,
  download: DownloadType = null
): RawAxiosRequestHeaders => {
  const awsToken = sessionStorage.getItem(AWS_AUTH_STORAGE_KEY);

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(awsToken ? { autho_api_aws: `Bearer ${awsToken}` } : {}),
    ...(cpfData?.cpfTitular ? { cpf: cpfData.cpfTitular } : {}),
    ...(cpfData?.cpfRespFinanc
      ? { cpf_resp_financ: cpfData.cpfRespFinanc }
      : {}),
    ...(download ? { tipo: download } : {}),
  };
};

export const getHeaders = (
  cpfData: CPFData | null = null,
  download: DownloadType = null
): AxiosRequestConfig => {
  return {
    headers: getHeaderValues(cpfData, download),
  };
};